module.exports = __webpack_public_path__ + "static/media/LOGO (4).688a6271.svg";